import { render } from "./BaseCardDetail.vue?vue&type=template&id=2fc7c279&scoped=true"
import script from "./BaseCardDetail.vue?vue&type=script&lang=js"
export * from "./BaseCardDetail.vue?vue&type=script&lang=js"

import "./BaseCardDetail.vue?vue&type=style&index=0&id=2fc7c279&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc7c279"]])

export default __exports__